import { Skeleton, Space } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import "../../css/custom.css";
import styles from "./cancellation.module.css";
import ViewCart from "./ViewCart";
import { getHotelDetails } from "../../redux/HomePage/actionCreater";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Header from "./Header";
import Footer from "./footer";

function Cancellation({}) {
  const [isFeatured, setIsFeatured] = useState(true);
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [load, setLoad] = useState(true);
  const [hotelData, setHotelData] = useState();
  const [color, setColor] = useState("#2d2a21");
  const params = useParams();
  const toggleFeatured = () => {
    setIsFeatured(!isFeatured);
  };
  const [windowWidth, setWindowWidth] = useState(
    window.innerWidth > 0 ? window.innerWidth : window.outerWidth
  );
  useEffect(() => {
    setWindowWidth(
      window.innerWidth > 0 ? window.innerWidth : window.outerWidth
    );
  }, [window.innerWidth > 0 ? window.innerWidth : window.outerWidth]);
  const [isFeatured1, setIsFeatured1] = useState(false);
  const [reservationData, setReservationData] = useState();
  const tableData = async () => {
    if (params.table_id != "home") {
      let response1 = await dispatch(getHotelDetails(params.table_id));
      if (response1 && response1.data) {
        setHotelData(response1.data);
        setColor(response1.data?.bg_color);
        setLoad(false);
      }
    } else {
      setLoad(false);
    }
  };
  useEffect(() => {
    if (!reservationData) {
      tableData();
    }
  }, [reservationData]);
  const toggleFeatured1 = () => {
    setIsFeatured1(!isFeatured1);
  };
  const [isFeatured2, setIsFeatured2] = useState(false);

  const toggleFeatured2 = () => {
    setIsFeatured2(!isFeatured2);
  };
  let cancellationData = hotelData?.cancel_policy
    ? hotelData?.cancel_policy
    : "";
  const navigateHomePage = () => {
    navigate(`/hotel/${params.table_id}`);
  };
  return (
    <>
      <div>
        <div className={styles.cardCustomerDetails}>
          <header
            className={styles.mainHeader}
            style={{ "--text-color": color }}
          >
            <div className="container">
              <div>
                <h1 style={{ cursor: "pointer" }} onClick={navigateHomePage}>
                  {hotelData?.hotel_name}
                </h1>
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-2  d-flex gap-3">
                    <i class="fa-solid fa-hotel"></i>
                    <p>Hotel Details</p>
                  </div>
                  <div className=" col-12 col-md-6 d-flex gap-3">
                    <i class="fa-solid fa-location-dot"></i>
                    <p>{hotelData?.hotel_address}</p>
                  </div>
                  <div className="col-12 col-md-6 col-lg-2 d-flex gap-3">
                    <i class="fa-solid fa-phone-volume"></i>
                    <a href="#">{hotelData?.hotel_mobile}</a>
                  </div>
                  <div className="col-12 col-md-6 col-lg-2 d-flex gap-3">
                    <i class="fa-regular fa-star"></i>
                    <p>4.8 (1285 reviews)</p>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <section className={styles.checkSection}>
            <div className="container ">
              <div className="d-flex align-items-center gap-3">
                <h2>Cancellation & Refund Policy</h2>
              </div>
              <br />
              <div className={styles.mainTextCancel}>
                <p className="text-muted">
                  {cancellationData
                    .slice(0, isFeatured ? cancellationData.length : 500)
                    .split(/\n+/)
                    .map((paragraph, index) => (
                      <p className="text-muted" key={index}>
                        {paragraph}
                      </p>
                    ))}
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
      {windowWidth > 800 && <Footer hotelData={hotelData} color={color} />}
    </>
  );
}

export default Cancellation;
